import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Declaration from '../components/pmcApp/Declaration';
import ChooseLandlord from '../components/pmcApp/ChooseLandlord';
import SelectGrantType from '../components/pmcApp/SelectGrantType';
import AuthRoute from '../AuthRoute';
import LandlordOrPmcPrivateParking from '../components/pmcApp/LandlordOrPmcPrivateParking';
import UnableToProceed from '../components/pmcApp/UnableToProceed';
import UnableToStartNewApplication from '../components/pmcApp/UnableToStartNewApplication';
import InstallerDetails from '../components/pmcApp/InstallerDetails';
import InstallerConfirm from '../components/pmcApp/InstallerConfirm';
import InstallationAddress from '../components/pmcApp/InstallationAddress';
import BuildingType from '../components/pmcApp/BuildingType';
import ChargepointInstallation from '../components/pmcApp/ChargepointInstallation';
import CheckYourPropertyAnswers from '../components/pmcApp/CheckAnswersProperty';
import ApplicationSubmitted from '../components/pmcApp/ApplicationSubmitted';
import StaffFleetChargepoints from '../components/pmcApp/StaffFleetChargepoints';
import UnableToProceedStaffOrFleetUsage from '../components/pmcApp/UnableToProceedStaffOrFleetUsage';
import ParkingType from '../components/pmcApp/ParkingType';
import ChallangeInstallation from '../components/landlordApp/ChallangeInstallation';
import ChallengeSubmitted from '../components/landlordReg/ChallengeSubmitted';
import ApprovalSubmitted from '../components/dashboardHub/ApprovalSubmitted';

export default function RoutesTreePmcApp() {
  return (
    <Switch>
      <AuthRoute exact path="/pmcApp/choose-landlord" isAnonymous>
        <ChooseLandlord />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/declaration" isAnonymous>
        <Declaration />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/select-grant-type">
        <SelectGrantType />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/commercial/staff-and-fleet">
        <StaffFleetChargepoints />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/commercial/unable-to-proceed">
        <UnableToProceedStaffOrFleetUsage />
      </AuthRoute>
      <AuthRoute
        exact
        path="/pmcApp/private-parking"
        component={LandlordOrPmcPrivateParking}
      />
      <AuthRoute exact path="/pmcApp/unable-to-start-new-application">
        <UnableToStartNewApplication />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/unable-to-proceed">
        <UnableToProceed />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/installer-details">
        <InstallerDetails />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/installer-confirm">
        <InstallerConfirm />
      </AuthRoute>
      <AuthRoute
        exact
        path="/pmcApp/installation-address"
        component={InstallationAddress}
      />
      <AuthRoute exact path="/pmcApp/building-type" component={BuildingType} />
      <AuthRoute exact path="/pmcApp/number-of-chargepoints">
        <ChargepointInstallation />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/check-your-answers">
        <CheckYourPropertyAnswers />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/application-submitted">
        <ApplicationSubmitted />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/parking-type" component={ParkingType} />
      <AuthRoute exact path="/pmcApp/challenge-installation">
        <ChallangeInstallation />
      </AuthRoute>
      <AuthRoute exact path="/pmcApp/challenge-submitted">
        <ChallengeSubmitted />
      </AuthRoute>
      <Route exact path="/pmcApp/approval-submitted">
        <ApprovalSubmitted />
      </Route>
    </Switch>
  );
}
